import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { SpeciesService } from 'src/app/application/service/SpeciesService';

import { Species } from 'src/app/domain/models/Species';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';
import { SpeciesUtils } from 'src/app/ui/util/species-utils';

@Component({
  selector: 'app-admin-manage-species',
  templateUrl: './admin-manage-species.component.html',
  styleUrls: ['./admin-manage-species.component.css'],

})
export class AdminManageSpeciesComponent implements OnInit {

  breadcrumbHome: MenuItem = {}

  species: Species[] = []
  loading: boolean = false
  profile: BasicUser | undefined

  constructor(
    private _speciesService: SpeciesService,
    private _router: Router,
    private _messageService: MessageService,
    private readonly _authService: AuthGateway,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.profile = this._authService.getUser()
    if (this.profile) {
      this.translate.use(this.profile.lang)
    }
    this.getSpecies()
    this.loadBreadcrumb()
  }

  loadBreadcrumb() {
    this.translate.get([
      'AdminSpeciesManagement.PageHomeTitle',
    ]).subscribe({
      next: (tranlations) => {
        this.breadcrumbHome = {
          label: tranlations['AdminSpeciesManagement.PageHomeTitle']
        }
      },
      error: () => {}
    })
  }

  getSpecies(){
    this.loading = true;
    this.species = [];
    this._speciesService.getAll().subscribe({
      next: (v) => {
        this.loading = false;
        this.species = v;
      },
      error: () => {
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant('AdminSpeciesManagement.Messages.FailedActionTitle'),
          detail: this.translate.instant('AdminSpeciesManagement.Messages.ErrorRetrievingSpeciesText')
        })
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  getIconUrl(url: string){
    return SpeciesUtils.getImageIcon(url);
  }

  goToCreateSpecies(){
    this._router.navigate(['/' + Routes.adminSpeciesNew]);
  }

  goToEditSpecies(specieId: string){
    this._router.navigate(['/', Routes.adminSpeciesEdit, specieId]);
  }
}
